// Predefined Leistungskatalog for Angebote (offers).
// Admin can add custom services at form time; this only defines the defaults.

export const UNITS = [
  { value: 'pauschal', label: 'Pauschal' },
  { value: 'monatlich', label: 'Monatlich' },
  { value: 'stündlich', label: 'Stündlich' },
];

export const SERVICE_CATEGORIES = [
  {
    id: 'websites',
    name: 'Websites & CMS',
    services: [
      { key: 'web-landingpage', name: 'Landing Page', default_price: 790, unit: 'pauschal' },
      { key: 'web-corporate', name: 'Unternehmenswebsite (mehrseitig)', default_price: 1890, unit: 'pauschal' },
      { key: 'web-wordpress', name: 'WordPress-Einrichtung', default_price: 590, unit: 'pauschal' },
      { key: 'web-schulung', name: 'CMS-Schulung', default_price: 90, unit: 'stündlich' },
    ],
  },
  {
    id: 'software',
    name: 'Software & Apps',
    services: [
      { key: 'sw-custom', name: 'Individuelle Software-Entwicklung', default_price: 95, unit: 'stündlich' },
      { key: 'sw-mobile', name: 'Mobile App Entwicklung', default_price: 3500, unit: 'pauschal' },
      { key: 'sw-api', name: 'API-Integration', default_price: 95, unit: 'stündlich' },
      { key: 'sw-db', name: 'Datenbank-Design', default_price: 850, unit: 'pauschal' },
    ],
  },
  {
    id: 'hosting',
    name: 'Hosting & Infrastruktur',
    services: [
      { key: 'host-web', name: 'Webhosting', default_price: 12, unit: 'monatlich' },
      { key: 'host-managed', name: 'Managed Server', default_price: 89, unit: 'monatlich' },
      { key: 'host-ssl', name: 'SSL-Zertifikat', default_price: 49, unit: 'pauschal' },
      { key: 'host-domain', name: 'Domain-Registrierung', default_price: 15, unit: 'pauschal' },
    ],
  },
  {
    id: 'support',
    name: 'Support & Wartung',
    services: [
      { key: 'sup-wartung', name: 'Wartungsvertrag', default_price: 79, unit: 'monatlich' },
      { key: 'sup-support', name: 'Technischer Support', default_price: 85, unit: 'stündlich' },
    ],
  },
];

export const ALL_SERVICES = SERVICE_CATEGORIES.flatMap((c) =>
  c.services.map((s) => ({ ...s, category: c.id, categoryName: c.name }))
);

export const findServiceByKey = (key) => ALL_SERVICES.find((s) => s.key === key);

export const unitLabel = (unit) => UNITS.find((u) => u.value === unit)?.label || unit;

export const formatEuro = (value) =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(Number(value) || 0);
